var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-edit","width":1200,"toptitle":"Projekt","title":`${_vm.project.title} bearbeiten`,"subtitle":_vm.lastUpdated}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-form',{attrs:{"project":_vm.project,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }